/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
import VueSelect from '../../js/vue-select.js';
import Datepicker from '../../js/vuejs-datepicker.min.js';
const __vue_script__ = {
    components: {
        full_loading: full_loading,
        vue_select: VueSelect,
        Datepicker: Datepicker,
    },
    name: 'upload_transfer_modal',
    props: {
    },
    data() {
        return {
            global,
                helper,
                frappe,
            is_loading: false,
            error: false,
            pending_request_name: null,
            pending_request_amount: null,
            payment_request_name: null,
            payment_url: null,
            transaction_amount:0.0
        }
    },
    mounted() {
        var exampleModal = document.getElementById('upload-transfer-modal');
        exampleModal.addEventListener('show.bs.modal', ()=>{
            this.transaction_amount = 0.0;
            this.payment_request_name = null;
            if(this.pending_request_name){
                console.log("after");
                this.payment_request_name = this.pending_request_name;
                this.transaction_amount = this.pending_request_amount;
            }
            this.payment_url = null;
        });
        global.emitter.on("set-transfer-balance", (args) => {
            console.log("before");
            if(args < 0){
                this.transaction_amount = 0;
            }else{
                this.transaction_amount = args;
            }
        });
        global.emitter.on("set-pending-payment", (args) => {
            this.pending_request_name = args['name'];
            this.pending_request_amount = args['amount'];
        });
    },
    methods: {
        process_payment_request: async function (){
            if(this.is_loading)
                return;
            this.is_loading = true;
            global.emitter.emit("show-full-loading");
            let params = {
                amount: this.transaction_amount
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.process_payment_request",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                this.payment_url = res.message;
                window.open(this.payment_url, '_blank');
                $('#upload-transfer-modal').modal('hide');
                location.reload();
                this.is_loading = false
                this.error = false;
                global.emitter.emit("hide-full-loading");
            } catch (e) {
                this.error = true;
                helper.showException(e);
            }
            global.emitter.emit("hide-full-loading");
            this.is_loading = false
        },
    }
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "upload-transfer-modal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            !_vm.is_loading
              ? _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.helper.t("Total amount to be paid"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.transaction_amount,
                              expression: "transaction_amount"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: { type: "number" },
                          domProps: { value: _vm.transaction_amount },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.transaction_amount = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.t(
                                "Minimum amount for each transaction: 10 SAR"
                              )
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row text-start mt-2" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _vm.transaction_amount >= 10
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { role: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.process_payment_request()
                                    }
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.helper.t("Pay now")))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ])
              : _c("p", { staticClass: "p-4" }, [
                  _vm._v(_vm._s(_vm.helper.t("Loading... Please wait.")))
                ])
          ])
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close"
        }
      })
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4d259942_0", { source: "\n.modal-content{\n    overflow: visible !important;\n}\n.modal-body{\n    overflow: unset !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/modal/upload-transfer-modal.vue"],"names":[],"mappings":";AA8HA;IACA,4BAAA;AACA;AACA;IACA,0BAAA;AACA","file":"upload-transfer-modal.vue","sourcesContent":["<template>\r\n    <div class=\"modal fade filter-popup-area\" id=\"upload-transfer-modal\" data-bs-backdrop=\"static\" data-bs-keyboard=\"false\"\r\n        tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n        <div class=\"modal-dialog modal-dialog-centered modal-dialog-scrollable\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                </div>\r\n                <div v-if=\"!is_loading\" class=\"modal-body\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"form-group\">\r\n                                <label>{{ helper.t(\"Total amount to be paid\") }}</label>\r\n                                <input v-model=\"transaction_amount\" type=\"number\" class=\"form-control border-radius\">\r\n                                <small>{{ helper.t(\"Minimum amount for each transaction: 10 SAR\") }}</small>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row text-start mt-2\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"d-flex justify-content-between\">\r\n                                <a v-if=\"transaction_amount >= 10\" class=\"btn btn-primary\"\r\n                                    role=\"button\"\r\n                                    @click=\"process_payment_request()\">\r\n                                <p>{{ helper.t(\"Pay now\") }}</p>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <p v-else class=\"p-4\">{{ helper.t(\"Loading... Please wait.\") }}</p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\";\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nimport VueSelect from '../../js/vue-select.js';\r\nimport Datepicker from '../../js/vuejs-datepicker.min.js';\r\nexport default {\r\n    components: {\r\n        full_loading: full_loading,\r\n        vue_select: VueSelect,\r\n        Datepicker: Datepicker,\r\n    },\r\n    name: 'upload_transfer_modal',\r\n    props: {\r\n    },\r\n    data() {\r\n        return {\r\n            global,\r\n                helper,\r\n                frappe,\r\n            is_loading: false,\r\n            error: false,\r\n            pending_request_name: null,\r\n            pending_request_amount: null,\r\n            payment_request_name: null,\r\n            payment_url: null,\r\n            transaction_amount:0.0\r\n        }\r\n    },\r\n    mounted() {\r\n        var exampleModal = document.getElementById('upload-transfer-modal');\r\n        exampleModal.addEventListener('show.bs.modal', ()=>{\r\n            this.transaction_amount = 0.0;\r\n            this.payment_request_name = null;\r\n            if(this.pending_request_name){\r\n                console.log(\"after\");\r\n                this.payment_request_name = this.pending_request_name;\r\n                this.transaction_amount = this.pending_request_amount;\r\n            }\r\n            this.payment_url = null;\r\n        });\r\n        global.emitter.on(\"set-transfer-balance\", (args) => {\r\n            console.log(\"before\");\r\n            if(args < 0){\r\n                this.transaction_amount = 0;\r\n            }else{\r\n                this.transaction_amount = args;\r\n            }\r\n        });\r\n        global.emitter.on(\"set-pending-payment\", (args) => {\r\n            this.pending_request_name = args['name'];\r\n            this.pending_request_amount = args['amount'];\r\n        });\r\n    },\r\n    methods: {\r\n        process_payment_request: async function (){\r\n            if(this.is_loading)\r\n                return;\r\n            this.is_loading = true;\r\n            global.emitter.emit(\"show-full-loading\");\r\n            let params = {\r\n                amount: this.transaction_amount\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.process_payment_request\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.payment_url = res.message;\r\n                window.open(this.payment_url, '_blank');\r\n                $('#upload-transfer-modal').modal('hide');\r\n                location.reload();\r\n                this.is_loading = false\r\n                this.error = false;\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            } catch (e) {\r\n                this.error = true;\r\n                helper.showException(e);\r\n            }\r\n            global.emitter.emit(\"hide-full-loading\");\r\n            this.is_loading = false\r\n        },\r\n    }\r\n}\r\n</script>\r\n\r\n<style>\r\n    .modal-content{\r\n        overflow: visible !important;\r\n    }\r\n    .modal-body{\r\n        overflow: unset !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/upload-transfer-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__